import { Dialog, Transition } from '@headlessui/react'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { Fragment } from 'react'

export const ChallengeModal = ({ open = false, closeModal, hasAccess }) => {
    const router = useRouter()

    const onSignUpClicked = () => {
        void router.push('/membership')
        closeModal()
    }

    return (
        <>
            <Transition appear show={open} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-50 overflow-y-auto"
                    onClose={closeModal}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-900 opacity-50" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                                {hasAccess ? (
                                    <img
                                        src="/achievement.png"
                                        width="200px"
                                        height="auto"
                                        className="mx-auto mb-4"
                                    />
                                ) : (
                                    <img
                                        src="/unlock.png"
                                        width="200px"
                                        height="auto"
                                        className="mx-auto mb-4"
                                    />
                                )}
                                <Dialog.Title
                                    as="h3"
                                    className="text-xl text-center font-medium leading-6 text-yf-green"
                                >
                                    {hasAccess ? (
                                        <span>We&#39;re Sorry!</span>
                                    ) : (
                                        'Want to start this Challenge?'
                                    )}
                                </Dialog.Title>
                                <div className="mt-2">
                                    <p className="text-center text-gray-500">
                                        {hasAccess
                                            ? 'Please head over to the mobile app to log workouts and complete this Challenge.'
                                            : 'You can gain access to this Challenge and many more Fitness events for FREE by signing up for VIP Membership!'}
                                    </p>
                                </div>

                                <div className="mt-4 flex items-center justify-center">
                                    {!hasAccess ? (
                                        <button
                                            type="button"
                                            className="mr-2 inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-yf-green border border-transparent rounded-md hover:bg-yf-green-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-yf-green-500"
                                            onClick={onSignUpClicked}
                                        >
                                            Yes, give me more!
                                        </button>
                                    ) : (
                                        <div>
                                            <div className="flex items-center justify-center">
                                                <a href="https://yesfit.app.link/google-play">
                                                    <Image
                                                        alt="Google Play store button"
                                                        src="/playstore.png"
                                                        width="168px"
                                                        height="49.9px"
                                                        priority
                                                    />
                                                </a>
                                                <a href="https://yesfit.app.link/app-store">
                                                    <Image
                                                        alt="Apple App store button"
                                                        src="/appstore.png"
                                                        width="168px"
                                                        height="49.9px"
                                                        priority
                                                    />
                                                </a>
                                            </div>
                                            <button
                                                className="hidden"
                                                onClick={closeModal}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
